module.exports = __webpack_public_path__ + "static/tuskegee-e8f8974cc0bbe065a36559e215b14ca3.gif";